import * as React from 'react';
import { Stack, Checkbox, CheckboxGroup, CheckboxProps, Box } from '@chakra-ui/react';
import { ICheckbox } from '../../../types';
import { withConfirm } from '../withConfirm';
import { CustomFormControl, DirectionProp } from '../CustomFormControl';

interface IProps extends DirectionProp {
  id?: string;
  subText?: string;
  errorText?: string;
  checkboxes: ICheckbox[];
  labelText?: string;
  onChange: (id: string, isTicked: boolean) => void;
  onBlur?: (event: React.FormEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FormEvent<HTMLInputElement>) => void;
  size?: 'lg' | 'md' | 'sm';
  mb?: number | string;
  checkboxProps?: CheckboxProps;
  name?: string;
}

const CheckboxOptions: React.FC<IProps> = (props: IProps) => {
  const {
    id,
    subText,
    errorText,
    checkboxes,
    labelText,
    onChange,
    onBlur,
    onFocus,
    size = 'lg',
    mb = 0,
    direction,
    checkboxProps,
  } = props;

  return (
    <CustomFormControl
      id={id}
      controlProps={{
        as: 'fieldset',
        borderWidth: 0,
        isInvalid: !!errorText,
        m: 0,
        p: 0,
        mb,
      }}
      direction={direction}
      size={size}
      label={labelText}
      labelProps={{ as: 'legend' }}
      subLabel={subText}
      error={errorText}
    >
      <CheckboxGroup variant="outline" size={size}>
        <Stack rowGap={2} columnGap={{ base: 2, lg: 4 }}>
          {checkboxes.map((checkbox: ICheckbox, i: number) => (
            <Checkbox
              key={i}
              id={`${id}-${checkbox.id}`}
              data-selector={`checkbox-value-${checkbox.id}`}
              isChecked={!!checkbox.isTicked}
              isReadOnly={!!checkbox.readOnly}
              onChange={() => onChange(checkbox.id, !checkbox.isTicked)}
              onBlur={onBlur}
              onFocus={onFocus}
              {...checkboxProps}
            >
              {checkbox.label}

              {checkbox.subLabel && (
                <Box fontSize={'sm'} color={'slightly-muted'} my={1}>
                  {checkbox.subLabel}
                </Box>
              )}
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
    </CustomFormControl>
  );
};

const CheckboxOptionsWithConfirm = withConfirm(CheckboxOptions);

export { CheckboxOptions, CheckboxOptionsWithConfirm };
